/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function CollectionOpened({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.998 13.401A1.402 1.402 0 0 1 1.6 12.094v-.182a1.41 1.41 0 0 1 .075-.37l1.784-5.14a.4.4 0 0 1 .378-.27h10.1a.4.4 0 0 1 .38.524l-1.876 5.778a1.4 1.4 0 0 1-1.332.967H3ZM.4 3.001v8.861a2.558 2.558 0 0 0 0 .285v.04c0 .05.006.097.017.142A2.602 2.602 0 0 0 2.998 14.6h8.111a2.6 2.6 0 0 0 2.473-1.797l1.876-5.777a1.6 1.6 0 0 0-1.522-2.095h-.556a2.538 2.538 0 0 0-2.474-1.968H6.662a1.6 1.6 0 0 0-1.6-1.564H2A1.6 1.6 0 0 0 .4 3Zm5.663 1.162a.6.6 0 0 1-.6-.6V3a.4.4 0 0 0-.4-.4H2a.4.4 0 0 0-.4.4v5.098l.725-2.09a1.6 1.6 0 0 1 1.512-1.076h8.28a1.338 1.338 0 0 0-1.21-.768H6.093l-.031-.001Z" clipRule="evenodd" /></svg>;
}
;